import { useEffect, useState } from "react";
import { getFromStorage, saveOnStorage } from "../utils/helpers";

const useLocalStorage = <T>(key: string, initialValue: T): [T, (data: T | string) => void] => {
  const [storedValue, setStoredValue] = useState(() => {
    if (typeof window === "undefined") {
      return initialValue;
    }
    try {
      const item = getFromStorage(key);
      return item || initialValue;
    } catch (error) {
      return initialValue;
    }
  });

  const setValue = (value) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      if (typeof window !== "undefined") {
        saveOnStorage(key, valueToStore);
      }
    } catch (error) {}
  };
  return [storedValue, setValue];
};

export { useLocalStorage };
